import React, { Component } from 'react'
import { UserActions, CountryActions } from 'actionsets'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import StyleSheet from 'styles'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import ShowIcon from '@material-ui/icons/KeyboardArrowRight'
import Table, { TableBody, TableRow, TableCell } from 'components/CollapsibleTable'
import {DateTimeDisplay} from 'components/DateTimeDisplay'
import CenteredContent from 'containers/CenteredContent'
import {connectQueryString} from 'containers/shared'
import Dependent from 'containers/shared/Dependent'
import {
  SearchComboInput,
  Pagination,
  Select,
  SortedTableHead,
  IndexActions,
  ActionIndicator,
  DateTimePicker,
  CountrySelect, FilterBar
} from 'components'
import Checkbox from 'components/styled/Checkbox'
import TextField from '@material-ui/core/TextField'

export class List extends Component {

  constructor(props){
    super(props)
    UserActions.bindActions(this)
    CountryActions.bindActions(this, 'country')
    this.state = {}
  }

  loadData = () => {
    const {filter, page, order} = this.props
    this.actions.country.index()
    this.actions.search({filter, page, order})
  }

  dependsOn = () => {
    return this.loadData()
  }

  dependenciesMet = () => {
    return this.props.requests.length === 0
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.query !== this.props.query)
      return this.loadData()
  }

  editUser = user => () => {
    this.props.history.push(`/users/${user.id}/edit`)
  }

  addUser = () => {
    this.props.history.push(`/users/new/`)
  }

  userType = user => {
    return [
      user.accessLevel === 'admin' && 'Admin',
      user.investorStatus !== 'not_applied' && 'Investor',
      user.issuerStatus !== 'not_applied' && 'Issuer'
    ].filter(t => t).join(', ')
  }

  accessLevelOptions = [{label: 'All', value: ''}, {label: 'Admin', value: 'admin'}, { label: 'Member', value: 'member' }]

  render = () => {
    const {search: {results, totalPages}} = this.props
    return (
      <CenteredContent>
        <Typography variant='h5'>Users</Typography>
        <FilterBar>
          <SearchComboInput>
            <div>
              <TextField focusFirst label='Email' member='email' fullWidth={false} className={styles.email}/>
              <TextField label='Name' member='name' fullWidth={false} style={{width: '200px'}}/>
            </div>
            <div>
              <DateTimePicker label='Created After' member='created_at.start' fullWidth={false} showDate/>
              <DateTimePicker label='Created Before' member='created_at.end' fullWidth={false} showDate/>
            </div>
            <div>
              <CountrySelect label='Country' member='country.id' countries={this.props.countries}/>
            </div>
            <div>
              <Select className={styles.inline} label='Type' attribute='access_level' fullWidth={false}
                                options={this.accessLevelOptions}/>
              <Typography className={styles.checkBox}><Checkbox type="checkbox" member='investor'/>Investors</Typography>
              <Typography className={styles.checkBox}><Checkbox type="checkbox" member='issuer'/>Issuers</Typography>
              <Typography className={styles.checkBox}><Checkbox type="checkbox" member='pending_review'/>Action Needed</Typography>
            </div>
          </SearchComboInput>
          <IndexActions exportLink="/api/users.csv"/>
          <Button variant='contained' color='primary' onClick={this.addUser}>Create</Button>
        </FilterBar>
        {this.renderResults(results)}
        <Pagination totalPages={totalPages} showAll/>
      </CenteredContent>
    )
  }

  renderResults = results => {
    return ((!results.length) ? <Typography className={styles.emptyListMsg}>No matching users</Typography> :
      <Table breakpoint={1000}>
        <SortedTableHead>
          <TableRow>
            <TableCell orderBy='name'>Name</TableCell>
            <TableCell orderBy='email'>Email</TableCell>
            <TableCell orderBy='createdAt'>Joined</TableCell>
            <TableCell orderBy='country'>Country</TableCell>
            <TableCell orderBy='accessLevel'>Type</TableCell>
            <TableCell onlyPrint>Address</TableCell>
            <TableCell dontPrint className={styles.actionRequiredCell}>Action needed</TableCell>
            <TableCell dontPrint/>
          </TableRow>
        </SortedTableHead>
        <TableBody>
          {results.map(result =>
            <TableRow key={result.id}>
              <TableCell mobileHeading><Link className={styles.link} to={`/users/${result.id}/edit`}>{result.name}</Link></TableCell>
              <TableCell mobileLabel="Email"><Link className={styles.link} to={`/users/${result.id}/edit`}>{result.email}</Link></TableCell>
              <TableCell mobileLabel="Joined"><DateTimeDisplay value={result.createdAt} type="date"/></TableCell>
              <TableCell mobileLabel="Country">{result.country.iso2}</TableCell>
              <TableCell mobileLabel="Type">{this.userType(result)}</TableCell>
              <TableCell onlyPrint>{result.fullAddress}</TableCell>
              <TableCell mobileHeading dontPrint className={styles.actionRequiredCell}>
                <ActionIndicator on={result.actionRequired} />
              </TableCell>
              <TableCell className={styles.actionButtons} mobileHeading dontPrint><IconButton
                onClick={this.editUser(result)}><ShowIcon/></IconButton></TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    )
  }

}

const styles = StyleSheet({
  emptyListMsg: {
    padding: '8px 16px',
    textAlign: 'center'
  },
  email: {
    width: '300px',
    '@media (max-width: 470px)': {
      width: 'calc(100vw - 170px)'
    }
  },
  actionButtons: {
    width: 1,
    '& button': {
      width: 32,
      height: 32,
    }
  },
  actionRequiredCell: {
    textAlign: 'center'
  },
  checkBox: {
    marginLeft: -13,
    display: 'inline-block',
    marginRight: 30
  },
  link: {
    color: 'rgba(0, 0, 0, 0.87)',
    textDecoration: 'none'
  }
})
export default connect(({users, countries}) => ({...countries, ...users}))(connectQueryString(Dependent({loader: true})(List)))